// extracted by mini-css-extract-plugin
export var container = "_8j-0";
export var error = "_8j-9";
export var label = "_8j-5";
export var light = "_8j-6";
export var md = "_8j-3";
export var sm = "_8j-2";
export var thin = "_8j-8";
export var thinBold = "_8j-7";
export var vertical = "_8j-4";
export var xs = "_8j-1";